import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { contentLibraryCopyFileRequested } from 'features/content-library/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* copyContentLibraryFileSaga(
  action: ReturnType<typeof contentLibraryCopyFileRequested>
) {
  yield call(SignalingSocket.send, {
    event: 'copyLibraryFile',
    data: { id: action.payload.id, personal: action.payload.personal },
  });

  if (action.payload.personal) {
    yield call(notification, i18n.t('notifications:content_library.file_copied_to_room'));
  } else {
    yield call(notification, i18n.t('notifications:content_library.file_copied_to_personal'));
  }
}
